import { Box, styled } from "@mui/material";

export const DEFAULT_SIDE_PANEL_WIDTH = 490;
export const MIN_SIDE_PANEL_WIDTH = 320;
export const MAX_SIDE_PANEL_WIDTH = 720;

export const MapPageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isResizing"
})<{ isResizing?: boolean }>(({ isResizing }) => ({
  display: "flex",
  width: "100%",
  height: "100vh",
  position: "relative",
  overflow: "hidden",
  userSelect: isResizing ? "none" : "auto",
  cursor: isResizing ? "col-resize" : "default"
}));

export const SidePanelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "panelWidth" && prop !== "isCollapsed"
})<{
  panelWidth: number;
  isCollapsed: boolean;
}>(({ theme, panelWidth, isCollapsed }) => ({
  width: isCollapsed ? 0 : `${panelWidth}px`,
  minWidth: isCollapsed ? 0 : `${MIN_SIDE_PANEL_WIDTH}px`,
  maxWidth: isCollapsed ? 0 : `${MAX_SIDE_PANEL_WIDTH}px`,
  height: "100vh",
  display: isCollapsed ? "none" : "flex",
  flexDirection: "column",
  backgroundColor: "#FFF",
  position: "relative",
  zIndex: 2,
  flexShrink: 0,
  borderRight: "1px solid #DFE5F4",
  [theme.breakpoints.down("sm")]: {
    width: isCollapsed ? 0 : "100%",
    maxWidth: isCollapsed ? 0 : "100%"
  }
}));

export const SidePanelHeader = styled(Box)({
  padding: "16px 16px 22px 16px",
  borderBottom: "1px solid #DFE5F4",
  backgroundColor: "#FFF",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  zIndex: 5,
  flexShrink: 0
});

export const SidePanelSearchRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  width: "100%"
});

export const SidePanelToolbarRow = styled(Box)({
  position: "absolute",
  right: "10px",
  bottom: 0,
  transform: "translateY(50%)",
  zIndex: 10,
  filter:
    "drop-shadow(0px 4px 15px rgba(55, 83, 125, 0.16)) drop-shadow(0px 2px 4px rgba(55, 83, 125, 0.16))"
});

export const SidePanelScrollableBox = styled(Box)({
  flex: 1,
  overflowY: "auto",
  overflowX: "hidden",
  position: "relative",
  backgroundColor: "#FFF"
});

export const SidePanelResizeHandle = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isResizing"
})<{ isResizing?: boolean }>(({ isResizing }) => ({
  width: "6px",
  height: "100vh",
  cursor: "col-resize",
  backgroundColor: isResizing ? "#00B2A3" : "transparent",
  position: "relative",
  zIndex: 10,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.15s ease-in-out",
  "&:hover": {
    backgroundColor: "rgba(0, 178, 163, 0.35)"
  },
  "&::after": {
    content: '""',
    width: "2px",
    height: "36px",
    borderRadius: "2px",
    backgroundColor: isResizing ? "#FFF" : "#C4CDD5"
  }
}));

export const MapCanvasWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSidePanelCollapsed"
})<{ isSidePanelCollapsed?: boolean }>(({ theme, isSidePanelCollapsed }) => ({
  flex: 1,
  minWidth: 0,
  height: "100vh",
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    display: isSidePanelCollapsed ? "block" : "none"
  }
}));

export const ExpandPanelFloatingContainer = styled(Box)({
  position: "absolute",
  top: "16px",
  left: "16px",
  zIndex: 20,
  pointerEvents: "auto"
});

export const MapActionsFloatingContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "10px",
  right: "10px",
  zIndex: 20,
  pointerEvents: "auto",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "calc(100% - 20px)"
  }
}));

export const CollapseTogglePill = styled(Box)({
  boxShadow: "0 0 4px 0 rgba(55, 83, 125, 0.16)",
  borderRadius: "100px",
  padding: "0px 10px 0px 8px",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  backgroundColor: "#FFF",
  cursor: "pointer",
  userSelect: "none",
  filter:
    "drop-shadow(0px 4px 15px rgba(55, 83, 125, 0.16)) drop-shadow(0px 2px 4px rgba(55, 83, 125, 0.16))",
  "&:hover": {
    backgroundColor: "#F5FFFE"
  }
});
